module.exports = new __parcel__URL__("WhiteboardsPaywallDark.0948bce6.svg").toString();